// import { useState, useEffect } from "react";

// type Toast = {
//   id: number;
//   message?: string;
// };

// const useToast = (timeout: number = 3000) => {
//   const [toasts, setToasts] = useState<Toast[]>([]);

//   const showToast = (message?: string) => {
//     const id = Date.now(); // Unique ID for each toast
//     setToasts((prev) => [...prev, { id, message }]);

//     // Remove toast after timeout
//     setTimeout(() => {
//       setToasts((prev) => prev.filter((toast) => toast.id !== id));
//     }, timeout);
//   };

//   return { toasts, showToast };
// };

// export default useToast;

import { createContext, useContext, useState, ReactNode } from "react";

type Toast = {
  icon?: string;
  id: number;
  message: string;
};

type ToastContextType = {
  toasts: Toast[];
  showToast: (message: string) => void;
};

const ToastContext = createContext<ToastContextType | undefined>(undefined);

export const ToastProvider = ({ children }: { children: ReactNode }) => {
  const [toasts, setToasts] = useState<Toast[]>([]);

  const showToast = (message: string, icon?: string) => {
    const id = Date.now();
    setToasts((prev) => [...prev, { id, message, icon }]);

    setTimeout(() => {
      setToasts((prev) => prev.filter((toast) => toast.id !== id));
    }, 5000); // Toast disappears after x seconds
  };

  return <ToastContext.Provider value={{ toasts, showToast }}>{children}</ToastContext.Provider>;
};

export const useToast = () => {
  const context = useContext(ToastContext);
  if (!context) {
    throw new Error("useToast must be used within a ToastProvider");
  }
  return context;
};
